const SignalTypeEnum = {
    Integer: "Integer",
    Boolean: "Boolean"
};

export default SignalTypeEnum;
